import { render, staticRenderFns } from "./VesselTrialTests.vue?vue&type=template&id=522a0bf0&scoped=true&"
import script from "./VesselTrialTests.vue?vue&type=script&lang=js&"
export * from "./VesselTrialTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a0bf0",
  null
  
)

export default component.exports